import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import MenuBar from './MenuBar';
const MenuBar = lazy(()=> import(/* webpackChunkName: "menubar" */'./MenuBar'))
const routes = () => [
  <PrivateRoute exact path="/menubar" key="/menubar" component={MenuBar} />
]
export default routes;


// WEBPACK FOOTER //
// src/modules/screens/menubar/routes.js